export class RaVersion {

    public static appPrefix: string = "/dev/rav2ng/";
    public static cssPrefix: string = "";
    public static full: string = "?v=1585256003";
    public static pocketsphinxVersion: string = "?v=1585256003";

}
